export function checkFileSize(file: File, maxMB: number) {
  const fileSizeMB = file.size / 1000 / 1000;
  if (fileSizeMB >= maxMB) {
    return { errorMessage: `サイズが大きすぎます。${maxMB}MB以下のファイルを選択してください。` };
  } else {
    return {};
  }
}

export function toBase64(file: File): Promise<string> {
  const reader = new FileReader();
  const promise = new Promise<string>((resolve, reject) => {
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
  reader.readAsDataURL(file);
  return promise;
}
